import * as React from 'react';
import { connect } from 'react-redux';
import {
  Title,
  RouteWrapper,
  AccessoryCreateForm,
  AccessoryList,
} from '../../components';
import { getAccessories } from '../../redux/actions/accessories';

interface Props {
  accessories: any;
  dispatch: Function;
}

class Route extends React.Component<Props> {
  componentDidMount() {
    this.props.dispatch(getAccessories());
  }

  render() {
    return (
      <RouteWrapper
        title="Accessories"
        requireAuth
        requirePermission="MANAGE_ACCESSORIES"
        breadcrumbs={[
          { link: '/settings', text: 'Settings' },
          { link: '/settings/accessories', text: 'Accessories' },
        ]}
      >
        <div className="container">
          <div className="columns">
            <div className="column">
              <Title>Accessories</Title>
              {(!this.props.accessories.isFetching ||
                this.props.accessories.accessories.length > 0) && (
                <AccessoryList items={this.props.accessories.accessories} />
              )}
            </div>
            <div className="column is-5">
              <AccessoryCreateForm />
            </div>
          </div>
        </div>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ accessories }) => ({
  accessories,
});

export default connect(mapStateToProps)(Route);
